import React from 'react';
import { useNavigate } from 'react-router';
import { Container, Button } from 'react-bootstrap';

function PageNotFound() {
  const navigate = useNavigate();

  const handleGoBack = () => {
    navigate('/');
  };

  return (
    <Container
      fluid
      className="d-flex flex-column justify-content-center align-items-center vh-100 bg-light text-center"
    >
      <h1 className="display-1 fw-bold text-primary">404</h1>
      <h2 className="fw-semibold mb-3">Page Not Found</h2>
      <p className="text-muted mb-4 px-3" style={{ maxWidth: '600px' }}>
        The page you are looking for might have been removed, had its name
        changed, or is temporarily unavailable.
      </p>
      <Button variant="dark" onClick={handleGoBack}>
        Return to Homepage
      </Button>
    </Container>
  );
}

export default PageNotFound;
